import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
    overflowY: 'auto',
    maxHeight: 450,
    minHeight: 350,
    overflowX: 'hidden'
  },

  noHistory: {
    flex: 1,
    minHeight: 350,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: theme.app.typography.h3.fontSize,
    color: theme.palette.primary.main,
    fontWeight: 500
  },

  loadingContainer: {
    flex: 1,
    minHeight: 350,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
    alignSelf: 'flex-start'
  },

  dateGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },

  dateHeader: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.body.fontSize,
    paddingBottom: 4,
    borderBottom: `1px solid ${theme.palette.divider}`
  },

  dateItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },

  card: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.app.colors.input.background,
    transition: 'background 0.2s',
    '&:hover': {
      backgroundColor: theme.app.colors.input.backgroundStrong
    }
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,

    '& span:first-child': {
      fontWeight: 500,
      color: theme.palette.primary.main,
      fontSize: theme.app.typography.body.fontSize
    },

    '& span:last-child': {
      fontWeight: 500,
      color: '#000',
      fontSize: theme.app.typography.label.fontSize
    }
  }
}))
